import { api, setConfig } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const getRealBonusHistory = (data: PropertyType): Promise<PropertyType[]> => {
	return api.post(`players/real-bonus-history`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return res.data.data;
	});
};
